module.exports = __webpack_public_path__ + "static/media/jackie.10b856ef.jpeg";